import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { StartCartaSyncInput, StartCartaSyncPayload } from "@oysterhr/schema"

export const START_CARTA_SYNC = gql`
  mutation StartCartaSync($companyId: ID!) {
    startCartaSync(input: { companyId: $companyId }) {
      errors
    }
  }
`

type MutationPayload = { startCartaSync: StartCartaSyncPayload }

export const useStartCartaSync = (
  options?: InjectedOptions<MutationPayload, StartCartaSyncInput>,
) => {
  return useMutation(START_CARTA_SYNC, options)
}
